import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { examsAPI } from "../services/api";
import "../styles/ExamDetails.css";

const ExamDetails = () => {
  const { courseId, examId } = useParams();
  const [exam, setExam] = useState(null);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await examsAPI.getDetails(examId);

        console.log("📡 استجابة MySQL للأسئلة:", response.data);

        if (response.data && response.data.questions) {
          const parsedQuestions = response.data.questions.map((q) => {
            const parsedOptions = {};
            if (q.options) {
              q.options.forEach((opt, index) => {
                const letter = String.fromCharCode(97 + index); // a, b, c, d
                parsedOptions[letter] = opt.option_text;
                if (opt.is_correct) q.correct_answer = opt.option_text;
              });
            }
            return {
              question_id: q.id,
              question_text: q.question_text || "❓ سؤال غير متوفر",
              options: parsedOptions,
              correct_answer: q.correct_answer || "❌ غير محدد",
            };
          });

          setExam(response.data.exam);
          setQuestions(parsedQuestions);
        } else {
          console.warn("⚠️ لم يتم العثور على أسئلة.");
          setQuestions([]);
        }
      } catch (error) {
        console.error("❌ حدث خطأ أثناء جلب الأسئلة:", error);
        alert("❌ حدث خطأ أثناء جلب الأسئلة. حاول مرة أخرى.");
      }
    };

    fetchQuestions();
  }, [courseId, examId]);

  return (
    <div className="exam-details-page">
      {/* Header Card */}
      <div className="exam-header-card">
        <div className="exam-icon-large">📝</div>
        <div className="exam-header-info">
          <h2>تفاصيل الامتحان {exam ? `- ${exam.title}` : ""}</h2>
          <div className="exam-meta">
            {exam && (
              <>
                <span>🕒 المدة: {exam.duration_minutes} دقيقة</span>
                <span>📋 الأسئلة: {questions.length}</span>
                <span>مفتوح: {exam.is_published ? "نعم" : "لا"}</span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Questions List */}
      <div className="questions-container">
        {questions.length > 0 ? (
          questions.map((question, index) => (
            <div key={question.question_id} className="question-card">
              <div className="question-header">
                <h4>
                  {index + 1}. {question.question_text}
                </h4>
                <span className="question-badge">خيارات متعددة</span>
              </div>

              <div className="options-grid">
                {Object.entries(question.options).map(([key, option]) => {
                  const isCorrect = option === question.correct_answer;
                  return (
                    <div key={key} className={`option-item ${isCorrect ? "correct" : ""}`}>
                      <div className="option-letter">{key.toUpperCase()}</div>
                      <div className="option-text">{option}</div>
                    </div>
                  );
                })}
              </div>

              <div className="correct-answer-footer">
                ✅ الإجابة الصحيحة: {question.correct_answer}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <div className="empty-icon">📂</div>
            <p>لا توجد أسئلة في هذا الامتحان حتى الآن.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExamDetails;
